import React from "react";
import {
  Table,
  Popup,
  Button,
  Icon,
  Confirm,
  Dropdown,
} from "semantic-ui-react";

import Can from "../../containers/Permission";

class UsersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: -1,
      openConfirm: false,
      openConfirmImpersonateUser: false,
      impersonateUserID: -1,
      userToRemove: -1,
    };
  }

  // select the clicked user
  clicked(id) {
    this.setState({ selected: id }, () => {
      this.props.userSelected(id);
    });
  }

  // handle color change onclick in table
  colorRow(rowId) {
    if (this.state.selected === rowId) return true;
    else return false;
  }

  // handle remove user from team
  handleRemove() {
    if (
      this.props.users.filter((el) => {
        return el.user_id === this.state.userToRemove;
      }).length > 1
    ) {
      this.props.removeUser(this.state.userToRemove);
    } else {
      this.props.removeUser(-1);
    }
    this.setState({ openConfirm: false });
  }

  // close confirm delete user from team
  discard() {
    this.setState({ openConfirm: false });
  }

  // call props modify user
  mod(id) {
    this.props.modUser(id);
  }

  // change role of the selected user to add
  changeRole(e, { value }) {
    this.props.changeRole(value);
  }

  // open confirm delete user from team
  showConfirm(id) {
    this.setState({
      openConfirm: true,
      userToRemove: id,
    });
  }

  // handle openClose confirm impersonate user
  openCloseImpersonateUser(id, e) {
    this.setState({
      openConfirmImpersonateUser: !this.state.openConfirmImpersonateUser,
      impersonateUserID: id,
    });
  }

  // MAIN RENDER
  render() {
    let loggedUserRoleIndex = 0,
      loggedUserRoleWeight = 0,
      roleOptions = [];
    if (this.props.roles && this.props.userRoleID) {
      loggedUserRoleIndex = this.props.roles.findIndex(
        (role) => role.id === this.props.userRoleID
      );
      loggedUserRoleWeight = this.props.roles[loggedUserRoleIndex].weight;
    }

    let rows = this.props.users.map((item, idx) => {
      let itemRoleIndex = 0,
        itemRoleWeight = 0;
      if (this.props.roles) {
        itemRoleIndex = this.props.roles.findIndex(
          (role) =>
            role.id === (item.role_id ? item.role_id : item.user.role_id)
        );
        itemRoleWeight = this.props.roles[itemRoleIndex].weight;
      }

      if (this.props.loggedUser) {
        let weightLoggedUser = this.props.roles.filter(
          (role) => role.id === this.props.loggedUser.role_id
        )[0].weight;
        roleOptions = this.props.roles.filter(
          (item) => item.weight < weightLoggedUser
        );
        roleOptions = roleOptions.map((item) => ({
          text: item.role_desc,
          value: item.id,
        }));
      }

      let itemID = item.user.id ? item.user.id : item.id;

      return (
        <Table.Row
          key={idx}
          onClick={() => {
            this.props.selectable
              ? this.clicked(item.user.id ? item.user.id : item.id)
              : null;
          }}
          style={{ cursor: "pointer" }}
          positive={
            this.state.selected === (item.user.id ? item.user.id : item.id)
              ? true
              : false
          }
        >
          <Table.Cell>{item.user.id ? item.user.id : item.id}</Table.Cell>
          <Table.Cell>{item.user.name ? item.user.name : item.name}</Table.Cell>
          <Table.Cell>{item.user.user ? item.user.user : item.user}</Table.Cell>
          <Table.Cell>
            {item.user.email ? item.user.email : item.email}
          </Table.Cell>
          <Table.Cell hidden={this.props.manageUsers}>
            <Dropdown
              disabled={this.state.selected !== itemID}
              placeholder="Seleziona Ruolo"
              fluid
              selection
              options={roleOptions}
              value={this.props.selectedRole}
              onChange={this.changeRole.bind(this)}
            />
          </Table.Cell>
          <Table.Cell hidden={!this.props.manageUsers}>
            {item.user.organization
              ? item.user.organization
              : item.organization}
          </Table.Cell>
          <Table.Cell hidden={!this.props.manageUsers}>
            {item.user.web_site ? item.web_site : item.link_web}
          </Table.Cell>
          <Table.Cell
            hidden={!this.props.manageUsers}
            style={this.props.manageUsers ? { display: "inline-flex" } : {}}
          >
            {/* <Can perform='can_manage_team'>
            <Popup
              trigger={<Button circular icon={<Icon name='remove user' size='large'/>} onClick={()=>this.showConfirm(item.user_id ? item.user_id : item.id)}/>}
              content= {t("POPUP_DEL")}
              />
          </Can> */}
            <Can perform="can_manage_staff">
              <Popup
                trigger={
                  <Button
                    circular
                    icon={<Icon name="random" size="large" />}
                    onClick={this.openCloseImpersonateUser.bind(
                      this,
                      item.user.id
                    )}
                    disabled={
                      item.user.id === this.props.loggedUserID ? true : false
                    }
                  />
                }
                content="Impersonifica utente"
              />
            </Can>
            <Can perform="can_manage_user">
              <Popup
                trigger={
                  <Button
                    circular
                    icon={<Icon name="edit" size="large" />}
                    onClick={() => {
                      this.props.openEdit(item);
                    }}
                    disabled={
                      itemRoleWeight > loggedUserRoleWeight ? true : false
                    }
                  />
                }
                content="Modifica dati"
              />
            </Can>
            <Can perform="can_manage_user">
              <Popup
                trigger={
                  <Button
                    circular
                    disabled ={item.user.id === this.props.loggedUserID}
                    icon={
                      <Icon
                        name={item.status === 1 ? "unlock" : "lock"}
                        size="large"
                      />
                    }
                    color={item.status === 1 ? undefined : "red"}
                    onClick={() => {
                      this.props.openBlock(item);
                    }}
                  />
                }
                content="Blocca/Sblocca utente nel team"
              />
            </Can>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <Table celled selectable={this.props.selectable}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Nome</Table.HeaderCell>
            <Table.HeaderCell>Username</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell hidden={this.props.manageUsers}>
              Ruolo
            </Table.HeaderCell>
            <Table.HeaderCell hidden={!this.props.manageUsers}>
              Organizzazione
            </Table.HeaderCell>
            <Table.HeaderCell hidden={!this.props.manageUsers}>
              Sito Web
            </Table.HeaderCell>
            <Table.HeaderCell hidden={!this.props.manageUsers}>
              Azioni
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows}
          <Confirm
            open={this.state.openConfirm}
            onCancel={this.discard.bind(this)}
            onConfirm={this.handleRemove.bind(this)}
            content="Sei sicuro di voler eliminare questo utente dal team?"
            header="Conferma azione"
          />
          <Confirm
            open={this.state.openConfirmImpersonateUser}
            onCancel={this.openCloseImpersonateUser.bind(this, -1)}
            onConfirm={() =>
              this.props.takeControlUser(this.state.impersonateUserID)
            }
            content="Sei sicuro di voler impersonare questo utente?"
            header="Conferma azione"
          />
        </Table.Body>
      </Table>
    );
  }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/administration/components/UsersTable.js